"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingProfileContent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const storage_1 = require("@completeanatomy/storage");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const missing_profile_image_svg_1 = __importDefault(require("../../assets/images/missing-profile-image.svg"));
const PrimaryButton_1 = require("../../atoms/PrimaryButton/PrimaryButton");
const Subtitle_1 = require("../../atoms/Subtitle/Subtitle");
const Title_1 = require("../../atoms/Title/Title");
const Progress_1 = require("../../context/Progress");
const withDelayedAppearance_1 = require("../../hocs/withDelayedAppearance");
const router_1 = require("../../router");
const mediaQueries_1 = require("../../styles/mediaQueries");
const SurveyPageContentTemplate_1 = require("../../templates/SurveyPageContentTemplate/SurveyPageContentTemplate");
function MissingProfileContent() {
    const { t } = (0, i18n_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [, dispatch] = (0, Progress_1.useProgress)();
    const storage = (0, storage_1.useStorageService)();
    const [isContinueButtonDisabled, setIsContinueButtonDisabled] = (0, react_1.useState)(false);
    const selectUserTypeRoute = `${router_1.Route.Base}/${router_1.Route.ProfileSurvey}/${router_1.Route.SelectUserType}`;
    (0, react_1.useEffect)(() => {
        dispatch((0, Progress_1.setCurrentPage)(0));
        dispatch((0, Progress_1.setCanGoNext)(true));
        dispatch((0, Progress_1.setNextRoute)(selectUserTypeRoute));
        storage === null || storage === void 0 ? void 0 : storage.put('shouldShowUserSurvey', 'true');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onGoNext = () => {
        setIsContinueButtonDisabled(true);
        navigate(selectUserTypeRoute, { state: { canGoBack: true } });
    };
    return ((0, jsx_runtime_1.jsx)(SurveyPageContentTemplate_1.SurveyPageContentTemplate, { Image: missing_profile_image_svg_1.default, content: (0, jsx_runtime_1.jsxs)(RightContainer, { children: [(0, jsx_runtime_1.jsx)(StyledTitle, { children: t(i18n_1.Strings.userOnboarding.profileMissing.title) }), (0, jsx_runtime_1.jsx)(StyledSubtitle, { children: t(i18n_1.Strings.userOnboarding.profileMissing.subtitle) }), (0, jsx_runtime_1.jsx)(ButtonsContainer, { children: (0, jsx_runtime_1.jsx)(PrimaryButton_1.PrimaryButton, { onClick: onGoNext, disabled: isContinueButtonDisabled, children: t(i18n_1.Strings.userOnboarding.profileMissing.complete) }) })] }), "data-e2e": 'MissingProfileContent_SurveyPageContentTemplate' }));
}
const MissingProfileContentWithProviders = (0, storage_1.withStorageProvider)((0, withDelayedAppearance_1.withDelayedAppearance)(MissingProfileContent, 300, 200));
exports.MissingProfileContent = MissingProfileContentWithProviders;
const RightContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;

  ${mediaQueries_1.device.desktop `
    max-height: 625px;
  
    align-items: flex-start;
  `};
`;
const StyledTitle = (0, styled_components_1.default)(Title_1.Title) `
  margin-bottom: 16px;

  ${mediaQueries_1.device.desktop `
    height: 164px;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    
    text-align: left;
    margin-bottom: 40px;
  `}
`;
const StyledSubtitle = (0, styled_components_1.default)(Subtitle_1.Subtitle) `
  ${mediaQueries_1.device.desktop `
    height: 72px;
    
    text-align: left;
  `}
`;
const ButtonsContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin-top: auto;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
